import * as CryptoJS from 'crypto-js';

const configs = {
  mode: CryptoJS.mode.ECB,
  keySize: 128,
  padding: CryptoJS.pad.Pkcs7,
};

export const encrypt = (key: string, value: string) => {
  const utfKey = CryptoJS.enc.Utf8.parse(key);
  const config = {
    iv: utfKey,
    ...configs,
  };
  const cipherText = CryptoJS.AES.encrypt(value, utfKey, config).toString();
  return cipherText;
};

export const decrypt = (key: string, value: string) => {
  const utfKey = CryptoJS.enc.Utf8.parse(key);
  const config = {
    iv: utfKey,
    ...configs,
  };
  const decryptedData = CryptoJS.AES.decrypt(value, utfKey, config);
  return decryptedData.toString(CryptoJS.enc.Utf8);
};

export const decryptAESHex = (encryptedHex: string, secret: string): string => {
  const key = CryptoJS.enc.Utf8.parse(secret);
  const encryptedWordArray = CryptoJS.enc.Hex.parse(encryptedHex);
  const base64Encoded = CryptoJS.enc.Base64.stringify(encryptedWordArray);

  const decrypted = CryptoJS.AES.decrypt(base64Encoded, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};
